import React, { Fragment, useEffect, useState } from 'react';
import { Box, Button, Tooltip, Typography } from "@mui/material";
import TableContainer from "../../../Components/TableContainer/TableContainer";
import PROFILE_PHOTO_USER from '../../../Assets/Images/Common/avtar.png'
import CustomAction from '../../../Components/CustomAction/CustomAction';
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';
import Constant from '../../../Utils/Constant';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
const BlogManagement = () => {
  const pageSize = 30;
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [blogList, setBlogList] = useState([]);
  const [typeCheck, setTypeCheck] = useState(null);
  const columns = [
    { field: "rowid", headerName: "Sr.No.", minWidth: 100, },
    {
      field: "cover_img",
      headerName: "Thumbnail",
      minWidth: 50,
      renderCell: (params) => {
        return (
          <img src={params?.row?.cover_img ? `${Constant.BASE_URL}${params?.row?.cover_img}` : PROFILE_PHOTO_USER} alt='profile_photo' style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px'
          }} />
        )
      }
    },
    {
      field: "title",
      headerName: "Title",
      minWidth: 400,
      renderCell: (params) => {
        const title = params?.row?.title || "--";
        const truncatedSubtitle = title.length > 50 ? `${title.substring(0, 50)}...` : title;

        return (
          <Tooltip title={title}>
            <span>{truncatedSubtitle}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "subtitle",
      headerName: "subtitle",
      minWidth: 400,
      renderCell: (params) => {
        const subtitle = params?.row?.subtitle || "--";
        const truncatedSubtitle = subtitle.length > 50 ? `${subtitle.substring(0, 50)}...` : subtitle;

        return (
          <Tooltip title={subtitle}>
            <span>{truncatedSubtitle}</span>
          </Tooltip>
        );
      },
    },

    {
      field: "action",
      headerName: "Actions",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", gap: "2rem" }}>
            <CustomAction
              showDelete={true}
              showEdit={true}
              isEdit={() => navigate('/admin/update-blog', {
                state: {
                  blogId: params?.row?.id,
                  type: "Edit"
                }
              })}
              isDelete={() => handleDeleteBlog(params?.row?.id)}
            />
          </Box>
        );
      },
    },
  ];
  useEffect(() => {
    getBlogList();
  }, [page]);
  const getBlogList = async () => {
    setIsLoading(true);
    try {
      const response = await AxiosInstance.get(APILIST.GET_BLOG, {
        params: {
          count: page * pageSize,
          offset: pageSize,
        }
      });
      if (response && response?.data?.s) {
        const Rowdata = response?.data?.r?.map((data, i) => ({
          rowid: i + 1 + page * pageSize,
          ...data,
        }));
        setBlogList(Rowdata);
        setCount(response?.data?.c || 0);
      } else {
        setBlogList([]);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  }
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleDeleteBlog = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Blog",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#46adf2",
      cancelButtonColor: "#5b5d5d",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          id: id,
          status: 0,
        };
        try {
          const response = await AxiosInstance.post(
            APILIST.UPDATE_DELETE_BLOG,
            params
          );
          if (response?.data?.s === 1) {
            getBlogList();
            toast.success("Blog Deleted Sucessfully !.");
          }
        } catch (error) {
          toast.error("Failed to delete blog. Please try again.");
        }
      }
    });
  };
  return (
    <Fragment>
      <Box sx={{
        width: '100%',
        padding: '15px'
      }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            paddingBottom: '16px'
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "20px", md: "30px" },
              fontWeight: "500",
              paddingBottom: "10px",
              fontFamily: "Outfit",
            }}
          >
            Blog Management
          </Typography>
          <Button
            sx={{
              width: "120px",
              borderRadius: "15px",
              textTransform: "none",
              fontSize: "16px",
              background: "linear-gradient(180deg, #B191FF 0%, #D0BCFF 100%)",
              color: "black",
              padding: "0",
              margin: "0",
              height: '51px',
              "&:hover": {
                background: "linear-gradient(180deg, #B191FF 0%, #D0BCFF 100%)",
                color: "black",
              },
              fontFamily: "Outfit",
            }}
            onClick={() => navigate('/admin/add-blog')}
          >
            Add Blog
          </Button>
        </Box>
        <Box sx={{ padding: "24px 0px 24px 0px", borderTop: '1px solid #0000003D' }}>
          <Box sx={{ padding: "24px 0px 24px 0px" }}>
            <TableContainer
              rows={blogList}
              columns={columns}
              pageSize={pageSize}
              loading={isLoading}
              page={page}
              totalCount={count}
              handlePageChange={handlePageChange}
              isPagination={true}
            />
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default BlogManagement;
